import { useMutation } from '@tanstack/react-query';
import { IImpersonationContext, IOperationResultNoValue, ImpersonationBroker } from '../../extViewmodels';
import { WebsiteContent } from '../../extViewmodels/sdk/models/Website';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface Variables {
	websiteId: string;
	contentId: string;
	impersonationContext?: IImpersonationContext;
}

export function useDeleteWebsiteContentMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (content: WebsiteContent, params: Variables) => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: Variables) => {
			return userSession.webServiceHelper.callAsync<WebsiteContent>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `website/${params.websiteId}/content/${params.contentId}`,
					impersonationContext: params.impersonationContext,
				}),
				'DELETE'
			);
		},
		onError,
		onSuccess,
	});
}
